import React from "react";
import { useAuth } from "../../contexts/auth";
import OrganizationPicker from "../../pages/organization-picker/organization-picker";

/**
 * A JDTech super admin works inside one organization at a time. Until one is
 * chosen, the picker is shown instead of the app.
 */
export default function OrganizationGate({ children }) {
  const { needsOrganization } = useAuth();

  if (needsOrganization === true) {
    return <OrganizationPicker />;
  }

  return <>{children}</>;
}
